/**
 * Shared class strings and inline style objects for the listings screens.
 *
 * Moved verbatim out of AdminListingsPage.js during the L1 extraction; the
 * values are unchanged so the rendered markup stays byte-identical.
 */
export const cardClass =
  "rounded-[14px] border border-black/10 dark:border-white/[0.07] bg-white dark:bg-[#141824] p-6";

export const inputClass =
  "w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] bg-slate-100 dark:bg-[#111520] px-3 py-2.5 text-sm text-[#0f172a] dark:text-[#eef2ff] box-border";

export const labelClass = "mb-1.5 block text-[10px] font-semibold text-[#64748b] dark:text-[#6b7a9a]";

export const secondaryBtn = {
  padding: "8px 12px",
  borderRadius: "8px",
  background: "transparent",
  color: "#8090b0",
  cursor: "pointer",
  fontSize: "13px",
};

export const secondaryBtnClass = "border border-black/10 dark:border-white/[0.1]";
